import MarkdownIt from "markdown-it";

export const openAnchorInNewWindow = (e: MouseEvent) => {
    // @ts-expect-error missing description
    if (e.target?.nodeName === 'A') {
        // @ts-expect-error missing description
        const href = e.target?.getAttribute('href')

        if (href) {
            window.open(href)

            e.stopPropagation();
            e.preventDefault();
        }
    }
}

const markdown = new MarkdownIt({
    breaks: false, // css whitespace
    linkify: true,
    typographer: true
})
// .enable(['emphasis','list','linkify'])

export const markdownRenderer = (input: string) => markdown.render(input)
